<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6">
        <fg-input
          :type="`text`"
          :label="`Серия паспорта`"
          :labelKey="`passport_series`"
          v-model="data.passport"
        ></fg-input>
      </div>
      <div class="col-12 col-md-6">
        <fg-input
          :type="`text`"
          :label="`ПИНФЛ`"
          :labelKey="`pinfl`"
          v-model="data.pinfl"
        ></fg-input>
      </div>
    </div>
    <div class="install-control">
      <button @click="send" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  components: {},
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {
    this.data.passport = this.order.client.passport_number.replace(/\s/g, "");
    this.data.pinfl = this.order.client.PINFL;
  },
  methods: {
    send() {
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}client/info`,
        method: "POST",
        data: this.data,
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.data) {
            this.$emit("setStep", "client-open");
            this.$emit("input", response.data);
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$emit("setStep", "client-create");
          }
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 500);
        });
    },
  },
  data() {
    return {
      data: {
        pinfl: "30101992180104",
        passport: "AA1234567",
      },
    };
  },
};
</script>

